import {
  PRODUCTHANDOVER_LOADING,
  GET_PRODUCTHANDOVER,
  GET_PRODUCTHANDOVER_SUCCESS,
  GET_PRODUCTHANDOVER_FAIL,
  ADD_PRODUCTHANDOVER_SUCCESS,
  ADD_PRODUCTHANDOVER_FAIL,
  DELETE_PRODUCTHANDOVER_SUCCESS,
  DELETE_PRODUCTHANDOVER_FAIL,
  UPDATE_PRODUCTHANDOVER_SUCCESS,
  UPDATE_PRODUCTHANDOVER_FAIL,
  PRODUCTHANDOVER_RESET
} from "./actionType";

const INIT_STATE = {
  productHandovers: [],
  error: {},
};

const ProductHandover = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTHANDOVER_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTHANDOVER:
          return {
            ...state,
            productHandovers: action.payload.data,
            isProductHandoverCreated: false,
            isProductHandoverUpdate: false,
            isProductHandoverSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTHANDOVER_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTHANDOVER_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductHandoverCreated: false,
            isProductHandoverUpdate: false,
            isProductHandoverSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTHANDOVER: {
      return {
        ...state,
        isProductHandoverCreated: false,
        isProductHandoverUpdate: false,
        loading: true,
      };
    }

    case PRODUCTHANDOVER_LOADING: {
      return {
        ...state,
        isProductHandoverCreated: false,
        isProductHandoverUpdate: false,
        loading: true,
      };
    }

    case ADD_PRODUCTHANDOVER_SUCCESS:
      return {
        ...state,
        isProductHandoverCreated: true,
        loading: false,
        productHandovers: [action.payload.data, ...state.productHandovers],
      };

    case ADD_PRODUCTHANDOVER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTHANDOVER_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductHandoverCreated: true,
        productHandovers: state.productHandovers.filter(
          productHandover => productHandover.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTHANDOVER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTHANDOVER_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductHandoverCreated: true,
        isProductHandoverUpdate: true,
        productHandovers: state.productHandovers.map(productHandover =>
          productHandover.id.toString() === action.payload.data.id.toString() ? { ...productHandover, ...action.payload.data } : productHandover
        ),
      };

    case UPDATE_PRODUCTHANDOVER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTHANDOVER_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductHandover;